// One canonical network configuration for production and local development.
// In production NeonParty is same-origin behind nginx, so a missing build-time
// env variable must never turn into requests to "undefined/api/...".
const trimSlash = (value) => String(value || "").trim().replace(/\/+$/, "");
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";

export const HTTP_URL = trimSlash(process.env.REACT_APP_BACKEND_URL) || browserOrigin;
export const API_URL = `${HTTP_URL}/api`;
export const SOCKET_URL = trimSlash(process.env.REACT_APP_WS_BACKEND_URL) || HTTP_URL || browserOrigin;
